import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SidebarSellersContainerProps } from "../../../../interfaces/containers";
import Sidebar from "../../../../pages/Profile/Sellers/Sidebar";
import { 
    getSellers, 
    cleanSellers, 
    addSeller, 
    cleanAddSeller, 
    editSeller, 
    cleanEditSeller 
} from "../../../../actions/profile";

function mapStateToProps(state: SidebarSellersContainerProps) {
    return {
        user: state.auth.user,
        sellers: state.profile.sellers,
        branches: state.profile.branches
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getSellers,
        cleanSellers, 
        addSeller, 
        cleanAddSeller, 
        editSeller, 
        cleanEditSeller
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);